import Vue from 'vue'
import {
  Input,
  Radio,
  Button,
  Tooltip,
  Message,
} from 'element-ui'

Vue.use(Input)
Vue.use(Radio)
Vue.use(Button)
Vue.use(Tooltip)
Vue.prototype.$message = Message;



// WEBPACK FOOTER //
// ./src/utils/elComponents.js